<header class="main-content admin-header">

  <div class="header-left">
    <h5>{{nomeFantasia}}</h5>
    <span>Gestão completa dos módulos e permissões do sistema</span>
  </div>

  <!--Busca-->
  <div class="header-center">
    <div class="search-box">
      <i-lucide name="search" color="#FFFFFF99" size="15"></i-lucide>
      <input type="search" placeholder="Buscar páginas do sistema..." [(ngModel)]="searchTerm" [matAutocomplete]="auto"
        (input)="filtrar()" />

      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selecionar($event.option.value)">

        <mat-option *ngFor="let item of sugestoes" [value]="item">

          <div class="autocomplete-item">

            <div class="linha-principal">
              <span class="icone-modulo">
                <i-lucide name="{{ item.modulo.icone }}" size="18">
                </i-lucide>
              </span>

              <span class="nome-modulo">
                {{ item.modulo.nome }}
              </span>
            </div>

            <div class="linha-secundaria">
              <span class="badge-termo">{{ item.nome }}</span>
            </div>

          </div>

        </mat-option>

      </mat-autocomplete>

    </div>
  </div>

  <div class="header-right">
    <button id="darkTheme" class="btn btn-default" title="{{ darkColor ? 'Modo claro' : 'Modo escuro' }}"
      (click)="modetoggle()">
      <i-lucide name="sun" size="20" color="#4A5565"></i-lucide>
    </button>

    <app-notificacoes></app-notificacoes>

    <!-- PERFIL -->
    <div class="dropdown-wrapper">
      <div class="user-info" (click)="toggleProfile()">
        <div class="avatar">
          <img *ngIf="previewImage; else avatarInitials" [src]="previewImage" alt="Avatar do usuário" />
          <ng-template #avatarInitials>
            {{ getInitials(nomeSocial || nome) }}
          </ng-template>
        </div>
        <div class="user-text">
          <strong>{{nomeSocial || nome}}</strong>
          <span class="nivel-perfil">{{perfil}}</span>
        </div>
        <span><i-lucide name="chevron-down" size="15" color="#b9c3d9"></i-lucide></span>
      </div>

      <div class="dropdown profile" *ngIf="showProfile">
        <div class="profile-header">
          <div class="avatar details">
            <img *ngIf="previewImage; else avatarInitials" [src]="previewImage" alt="Avatar do usuário" />
            <ng-template #avatarInitials>{{getInitials(nomeSocial || nome)}}</ng-template>
          </div>
          <div class="drop-details">
            <strong class="name-profile">{{nomeSocial || nome}}</strong>
            <small class="email">{{email}}</small>
            <span class="role">{{perfil}}</span>
          </div>
          <button
            class="close-btn"
            type="button"
            (click)="showProfile = false"
            aria-label="Fechar perfil">
            <i-lucide name="x" size="18"></i-lucide>
          </button>
        </div>

        <a class="dropdown-item" (click)="meuPerfil()"><i-lucide name="user" size="16" color="#717182"></i-lucide> Meu
          Perfil</a>
        <a class="dropdown-item" (click)="configuracao()"><i-lucide name="settings" size="16"
            color="#717182"></i-lucide> Configurações</a>
        <a class="dropdown-item" (click)="trocarCliente()"><i-lucide name="arrow-right-left" size="16"
            color="#717182"></i-lucide> Trocar de Cliente </a>
        <a class="dropdown-item danger" (click)="logout()"><i-lucide name="log-out" size="16"
            color="#717182"></i-lucide> Sair</a>
      </div>
    </div>

  </div>
</header>